import { from, of } from 'rxjs';
import { ajax } from 'rxjs/ajax';
import { catchError, retry, switchMap } from 'rxjs/operators';
import { audioContext } from '../webAudio/audioContext';
import { assetsUrl } from './constants';

export const loadAudioBuffer = (sourceFilePath) =>
   ajax({
      url: `${assetsUrl}/public/sample/${sourceFilePath}`,
      responseType: 'arraybuffer',
      crossDomain: true,
   }).pipe(
      retry(3),
      switchMap(({ response }) => from(audioContext.decodeAudioData(response))),
      catchError(() => of(null))
   );
